import moment from "moment";
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import '../../../styles/reports/reports-common.scss';
import { focusElement, handlekeyDown } from '../../../components/generics/helper';
import BranchAutocomplete from '../../../components/formik-form-components/BranchAutocomplete';
import BrandAutocomplete from '../../../components/formik-form-components/BrandAutocomplete';
import CategoryAutocomplete from '../../../components/formik-form-components/CategoryAutocomplete';
import DatepickerV2 from '../../../components/shared/DatepickerV2';
import ItemAutocomplete from '../../../components/formik-form-components/ItemAutocomplete';
import POStatusAutocomplete from "../../../components/formik-form-components/POStatusAutocomplete";
import PurchaseOrderReportList from './PurchaseOrderReportList';
import UserAutocomplete from "../../../components/formik-form-components/UserAutocomplete";
import VendorAutocomplete from "../../../components/formik-form-components/VendorAutocomplete";

const PurchaseOrderReport = () => {    
    const userData = useSelector((state) => state.login.userData);
    const filterInitialValue = { fromDate: moment(new Date()).format("YYYY-MM-DD"), toDate: moment(new Date()).format("YYYY-MM-DD"), searchBillBranchIds: userData?.branchId ?? '',searchBillBranchNames: [], searchShipBranchIds: '',searchShipBranchNames: [], searchCategoryIds: '',searchCategoryNames:[], searchSuperCategory: '', searchSubCategoryIds: '',searchSubCategoryNames:[], searchBrandIds: '',searchBrandNames:[], searchItemIds: '',searchItemNames: [], searchVendorIds: '',searchVendorNames: [], searchPOCreatedByIds: '',searchPOCreatedByNames: [], searchPOStatus: '',searchPOStatusTitle:[], showTable: false };
    const [purchaseOrderReportFilters, setPurchaseOrderReportFilters] = useState(filterInitialValue);
    const [resetDate, setResetDate] = useState(false);
    const [loadData, setLoadData] = useState(false);

    const billBranchFilterRef = useRef(null);
    const shipBranchFilterRef = useRef(null);
    const itemFilterRef = useRef(null);
    const categoryFilterRef = useRef(null);
    const subCategoryFilterRef = useRef(null);
    const brandFilterRef = useRef(null);
    const vendorFilterRef = useRef(null);
    const poCreatedByFilterRef = useRef(null);
    const posFilterRef = useRef(null);

    const purchaseOrderReportFilterReset = () => {
        setPurchaseOrderReportFilters({ ...filterInitialValue });
        billBranchFilterRef.current.resetAutocomplete();
        shipBranchFilterRef.current.resetAutocomplete();
        itemFilterRef.current.resetAutocomplete();
        categoryFilterRef.current.resetAutocomplete();
        subCategoryFilterRef.current.resetAutocomplete();
        brandFilterRef.current.resetAutocomplete();
        vendorFilterRef.current.resetAutocomplete();
        poCreatedByFilterRef.current.resetAutocomplete();
        posFilterRef.current.resetAutocomplete();
        setResetDate(true);
    }

    const generatePurchaseOrderData = () => {
        setPurchaseOrderReportFilters((prev) => ({ ...prev, showTable: true }))
        setLoadData(true);
    }
    useEffect(() => {
        focusElement('purchaseOrderFromDate')
    }, [])

    return (
        <>
            <div key="por_wrapper" className="report--wrapper">
                <div key="por_filter_wrapper" className="report--filter--wrapper po--report--filter">
                    <div key="por_filter_inp_container" className="input--container">
                        <DatepickerV2
                            name={'filter_from_dt'}
                            type="filter_from_dt"
                            className=""
                            star={true}
                            label="From Date"
                            id="purchaseOrderFromDate"
                            Reset={resetDate}
                            dateChange={(newValue) => {
                                setResetDate(false);
                                setPurchaseOrderReportFilters(previousFilters => ({ ...previousFilters, fromDate: moment(newValue).format("YYYY-MM-DD"), showTable: false }));
                                focusElement("purchaseOrderToDate")
                            }}
                        />
                    </div>
                    <div key="por_filter_inp_tod" className="input--container" >
                        <DatepickerV2
                            name={'filter_to_dt'}
                            type="filter_to_dt"
                            className=""
                            star={true}
                            enableFuture={true}
                            emptyField={''}
                            label="To Date"
                            fromDate={purchaseOrderReportFilters?.fromDate}
                            id="purchaseOrderToDate"
                            Reset={resetDate}
                            dateChange={(newValue) => {
                                setResetDate(false);
                                setPurchaseOrderReportFilters(previousFilters => ({ ...previousFilters, toDate: moment(newValue).format("YYYY-MM-DD"), showTable: false }));
                                focusElement("searchPOBillBranchIds")
                            }}
                        />
                    </div>
                    <div key="por_filter_inp_branch" className="input--container" style={{ width: '14%' }}>
                        <BranchAutocomplete
                            id={'searchPOBillBranchIds'}
                            name={'searchPOBillBranchIds'}
                            label={"Bill Branch Name"}
                            searchPlaceholder={"Search By Bill Branch Name"}
                            noDataLabel={"No Bill Branch Found"}
                            isCompulsory={false}
                            singleSelect={false}
                            allOption={false}
                            // selectedValues={['']}
                            selectedValues={purchaseOrderReportFilters.searchBillBranchIds !== '' ? purchaseOrderReportFilters.searchBillBranchIds.split(',') : []}
                            listWidth={300}
                            onSelect={(selectedBranches, currentSelection) => {
                                const searchBillBranchIds = selectedBranches.map((b) => b.branchId).sort().join(',');
                                const searchBillBranchNames = selectedBranches.map((b) => b.branchName).sort();
                                setPurchaseOrderReportFilters(previousFilters => ({ ...previousFilters, searchBillBranchIds, searchBillBranchNames, showTable: false }));
                            }}
                            onRemove={(selectedBranches, currentSelection) => {
                                const searchBillBranchIds = selectedBranches.map((b) => b.branchId).sort().join(',');
                                const searchBillBranchNames = selectedBranches.map((b) => b.branchName).sort();
                                setPurchaseOrderReportFilters(previousFilters => ({ ...previousFilters, searchBillBranchIds, searchBillBranchNames, showTable: false }));
                            }}
                            ref={billBranchFilterRef}
                            nextId='searchPOShipBranchIds'
                            prevId=''
                        />
                    </div>
                    <div key="por_filter_inp_shipbranch" className="input--container" style={{ width: '14%' }}>
                        <BranchAutocomplete
                            id={'searchPOShipBranchIds'}
                            name={'searchPOShipBranchIds'}
                            label={"Ship Branch Name"}
                            searchPlaceholder={"Search By Ship Branch Name"}
                            noDataLabel={"No Ship Branch Found"}
                            isCompulsory={false}
                            singleSelect={false}
                            allOption={false}
                            selectedValues={['']}
                            listWidth={300}
                            onSelect={(selectedBranches, currentSelection) => {
                                const searchShipBranchIds = selectedBranches.map((b) => b.branchId).sort().join(',');
                                const searchShipBranchNames = selectedBranches.map((b) => b.branchName).sort();
                                setPurchaseOrderReportFilters(previousFilters => ({ ...previousFilters, searchShipBranchIds, searchShipBranchNames, showTable: false }));
                            }}
                            onRemove={(selectedBranches, currentSelection) => {
                                const searchShipBranchIds = selectedBranches.map((b) => b.branchId).sort().join(',');
                                const searchShipBranchNames = selectedBranches.map((b) => b.branchName).sort();
                                setPurchaseOrderReportFilters(previousFilters => ({ ...previousFilters, searchShipBranchIds, searchShipBranchNames, showTable: false }));
                            }}
                            ref={shipBranchFilterRef}
                            nextId='searchPOVendorIds'
                            prevId='searchPOBillBranchIds'
                        />
                    </div>
                    <div className="input--container">
                        <VendorAutocomplete
                            id="searchPOVendorIds"
                            name="searchPOVendorIds"
                            label="Vendor Name"
                            searchPlaceholder="Search By Vendor Name"
                            noDataLabel="No Vendor Name Found"
                            isCompulsory={false}
                            singleSelect={false}
                            allOption={false}
                            listWidth={window.innerWidth === 1024 ? 280 : 450}
                            selectedValues={purchaseOrderReportFilters.searchVendorIds ? purchaseOrderReportFilters.searchVendorIds.split(',') : []}
                            onSelect={(selectedVendors) => {
                                const searchVendorIds = selectedVendors.map((v) => v.vendorId).sort().join(',');
                                const searchVendorNames = selectedVendors.map((v) => v.vendorName).sort();
                                setPurchaseOrderReportFilters(prev => ({ ...prev, searchVendorIds, searchVendorNames, showTable: false }));
                            }}
                            onRemove={(selectedVendors) => {
                                const searchVendorIds = selectedVendors.map((v) => v.vendorId).sort().join(',');
                                const searchVendorNames = selectedVendors.map((v) => v.vendorName).sort();
                                setPurchaseOrderReportFilters(prev => ({ ...prev, searchVendorIds, searchVendorNames, showTable: false }));
                            }}
                            ref={vendorFilterRef}
                            nextId="searchPOUserIds"
                            prevId="searchPOShipBranchIds"
                        />
                    </div>
                    <div className="input--container">
                        <UserAutocomplete
                            id="searchPOUserIds"
                            name="searchPOUserIds"
                            label="PO Created by"
                            searchPlaceholder="Search PO Created by"
                            noDataLabel="No PO Created by Found"
                            isCompulsory={false}
                            singleSelect={false}
                            allOption={false}
                            listWidth={370}
                            selectedValues={purchaseOrderReportFilters.searchPOCreatedByIds ? purchaseOrderReportFilters.searchPOCreatedByIds.split(',') : []}
                            onSelect={(selectedUsers) => {
                                const searchPOCreatedByIds = selectedUsers.map((u) => u.crsUserId).sort().join(',');
                                const searchPOCreatedByNames = selectedUsers.map((u) => u.userName).sort();
                                setPurchaseOrderReportFilters(prev => ({ ...prev, searchPOCreatedByIds, searchPOCreatedByNames, showTable: false }));
                            }}
                            onRemove={(selectedUsers) => {
                                const searchPOCreatedByIds = selectedUsers.map((u) => u.crsUserId).sort().join(',');
                                const searchPOCreatedByNames = selectedUsers.map((u) => u.userName).sort();
                                setPurchaseOrderReportFilters(prev => ({ ...prev, searchPOCreatedByIds, searchPOCreatedByNames, showTable: false }));
                            }}
                            ref={poCreatedByFilterRef}
                            nextId="searchPOCategoryIds"
                            prevId="searchPOVendorIds"
                        />
                    </div>
                    <div key="por_filter_inp_category" className="input--container" style={{ width: '13%' }}>
                        <CategoryAutocomplete
                            id="searchPOCategoryIds"
                            name="searchPOCategoryIds"
                            nextId="searchPOSubCategoryIds"
                            prevId="searchPOUserIds"
                            label="Category"
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={250}
                            searchPlaceholder="Search By Category"
                            noDataLabel="No Category Found"
                            categoryFor={1}
                            isParent="Y"
                            selectedValues={purchaseOrderReportFilters.searchCategoryIds !== '' ? [purchaseOrderReportFilters.searchCategoryIds] : []}
                            onSelect={(selectedCategory, currentSelection) => {
                                const searchCategoryIds = selectedCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSuperCategory = selectedCategory.length > 0 ? selectedCategory[0].superCategory : '';
                                const searchCategoryNames = selectedCategory.map((c) => c.categoryTitle).sort();
                                setPurchaseOrderReportFilters(previousFilters => ({ ...previousFilters, searchCategoryIds, searchSuperCategory, searchCategoryNames, showTable: false }));
                            }}
                            onRemove={(selectedCategory, currentSelection) => {
                                const searchCategoryIds = selectedCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSuperCategory = selectedCategory.length > 0 ? selectedCategory[0].superCategory : '';
                                const searchCategoryNames = selectedCategory.map((c) => c.categoryTitle).sort();
                                setPurchaseOrderReportFilters(previousFilters => ({ ...previousFilters, searchCategoryIds, searchSuperCategory, searchCategoryNames, showTable: false }));
                            }}
                            ref={categoryFilterRef}
                        />
                    </div>
                    <div key="por_filter_inp_subCategory" className="input--container">
                        <CategoryAutocomplete
                            name="searchPOSubCategoryIds"
                            nextId="searchPOBrandIds"
                            prevId="searchPOCategoryIds"
                            id="searchPOSubCategoryIds"
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={250}
                            label="Sub Category"
                            searchPlaceholder="Search By Sub Category"
                            noDataLabel="No Sub Category Found"
                            categoryFor={1}
                            isParent="N"
                            selectedValues={purchaseOrderReportFilters.searchSubCategoryIds !== '' ? [purchaseOrderReportFilters.searchSubCategoryIds] : []}
                            onSelect={(selectedSubCategory, currentSelection) => {
                                const searchSubCategoryIds = selectedSubCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSubCategoryNames = selectedSubCategory.map((sc) => sc.categoryTitle).sort();
                                setPurchaseOrderReportFilters(previousFilters => ({ ...previousFilters, searchSubCategoryIds, searchSubCategoryNames, showTable: false }));
                            }}
                            onRemove={(selectedSubCategory, currentSelection) => {
                                const searchSubCategoryIds = selectedSubCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSubCategoryNames = selectedSubCategory.map((sc) => sc.categoryTitle).sort();
                                setPurchaseOrderReportFilters(previousFilters => ({ ...previousFilters, searchSubCategoryIds, searchSubCategoryNames, showTable: false }));
                            }}
                            ref={subCategoryFilterRef}
                        />

                    </div>
                    <div key="por_filter_inp_brand" className="input--container" >
                        <BrandAutocomplete
                            id={'searchPOBrandIds'} nextId="searchPOItemIds" prevId="searchPOSubCategoryIds"
                            name="searchPOBrandIds"
                            label="Brand"
                            searchPlaceholder="Search By Brand Category"
                            noDataLabel="No Brand Found"
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={350}
                            selectedValues={purchaseOrderReportFilters.searchBrandIds !== '' ? [purchaseOrderReportFilters.searchBrandIds] : ['']}
                            onSelect={(selectedBrands, currentSelection) => {
                                const searchBrandIds = selectedBrands.map((v) => v.brandId).sort().join(',');
                                const searchBrandNames = selectedBrands.map((b) => b.brandName).sort();
                                setPurchaseOrderReportFilters(previousFilters => ({ ...previousFilters, searchBrandIds, searchBrandNames, showTable: false }));
                            }}
                            onRemove={(selectedBrands, currentSelection) => {
                                const searchBrandIds = selectedBrands.map((v) => v.brandId).sort().join(',');
                                const searchBrandNames = selectedBrands.map((b) => b.brandName).sort();
                                setPurchaseOrderReportFilters(previousFilters => ({ ...previousFilters, searchBrandIds, searchBrandNames, showTable: false }));
                            }}
                            ref={brandFilterRef}
                        />
                    </div>
                    <div key="por_filter_inp_item" className="input--container" style={{ width: '14%' }} >
                        <ItemAutocomplete
                            name="searchPOItemIds"
                            label={"Item Name & Part No."}
                            searchPlaceholder={"Search By Item Name & Part No."}
                            noDataLabel={"No Item Found"}
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={450}
                            forAllItems={'Y'}
                            onlyLoginBranchMappedModelsItems={true}
                            selectedValues={purchaseOrderReportFilters.searchItemIds !== '' ? [purchaseOrderReportFilters.searchItemIds] : []}
                            onSelect={(selectedItems) => {
                                const searchItemIds = selectedItems.map((i) => i.itemId).sort().join(',');
                                const searchItemNames = selectedItems.map(i => i.itemName);
                                setPurchaseOrderReportFilters(previousFilters => ({ ...previousFilters, searchItemIds, searchItemNames, showTable: false }));
                            }}
                            onRemove={(selectedItems) => {
                                const searchItemIds = selectedItems.map((i) => i.itemId).sort().join(',');
                                const searchItemNames = selectedItems.map(i => i.itemName);
                                setPurchaseOrderReportFilters(previousFilters => ({ ...previousFilters, searchItemIds, searchItemNames, showTable: false }));
                            }}
                            ref={itemFilterRef}
                            id="searchPOItemIds"
                            nextId='searchPOStatusIds'
                            prevId='searchPOBrandIds'
                        />
                    </div>
                    <div className="input--container" style={{ width: '14%' }}>
                        <POStatusAutocomplete
                            id="searchPOStatusIds"
                            name="searchPOStatusIds"
                            label="PO Status"
                            searchPlaceholder="Search By PO Status"
                            noDataLabel="No PO Status Found"
                            isCompulsory={false}
                            singleSelect={false}
                            allOption={false}
                            listWidth={300}
                            selectedValues={purchaseOrderReportFilters.searchPOStatus ? purchaseOrderReportFilters.searchPOStatus.split(',') : []}
                            onSelect={(selectedPOStatus) => {
                                const searchPOStatus = selectedPOStatus.map((p) => p.id).sort().join(',');
                                const searchPOStatusTitle = selectedPOStatus.map((b) => b.label).sort();
                                setPurchaseOrderReportFilters(prev => ({ ...prev, searchPOStatus, searchPOStatusTitle, showTable: false }));
                            }}
                            onRemove={(selectedPOStatus) => {
                                const searchPOStatus = selectedPOStatus.map((p) => p.id).sort().join(',');
                                const searchPOStatusTitle = selectedPOStatus.map((b) => b.label).sort();
                                setPurchaseOrderReportFilters(prev => ({ ...prev, searchPOStatus, searchPOStatusTitle, showTable: false }));
                            }}
                            ref={posFilterRef}
                            nextId="generatePOR"
                            prevId="searchPOItemIds"
                        />
                    </div>
                    <div className='btn--container'>
                        <div className="dashed--btn" id="generatePOR" tabIndex="0" style={{ marginLeft: '0' }} onClick={() => { generatePurchaseOrderData(); }}
                            onKeyDown={(e) => { handlekeyDown(e, `purchaseOrderFromDate`, `resetBtn`, `generatePOR`) }}>Generate Report</div>
                        <div key="por_filter_inp_frd" className="dashed--btn" onClick={() => purchaseOrderReportFilterReset(false)}
                            id="resetBtn"
                            tabIndex="0"
                            onKeyDown={(e) => { handlekeyDown(e, `generatePOR`, `purchaseOrderFromDate`, `resetBtn`) }}>Reset
                        </div>
                    </div>
                </div>
                <div key="por_container" className="report--container">
                    {purchaseOrderReportFilters?.showTable &&
                        <PurchaseOrderReportList purchaseOrderReportFilters={purchaseOrderReportFilters} loadData={loadData} setLoadData={setLoadData} />
                    }
                </div>
            </div>
        </>
    )
}
export default PurchaseOrderReport;
